module.exports = "/images/Icon industry-QuestRoom.svg?ba9e9d5bcfa8ab1d5f811f64280b1d58";